import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);

    // Solo la navegacion: los widgets de demo de Fuse (mensajes,
    // notificaciones, atajos) se quitaron en 2026-09.
    return forkJoin([navigationService.get()]);
};
